<template>
    <div ref="toggleMenu" class="ly_toggleMenu">
        <div class="ly_toggleMenu_inner">
            <div class="toggleMenu">
                <p>
                    <img :src="`${dir}/src/assets/img/yusuugaku-logo-black.svg`"
                         alt="yusuugaku"
                         class="toggleMenu_img">
                </p>
                <nav class="toggleMenu_unit mt-80">
                    <ul class="toggleMenu_list ff_serif">
                        <li class="toggleMenu_item">
                            <router-link to="/"
                                         class="toggleMenu_link"
                                         @click.native="onLinkClick"
                            >
                                Home
                            </router-link>
                        </li>
                        <li class="toggleMenu_item">
                            <router-link to="/greeting"
                                         class="toggleMenu_link"
                                         @click.native="onLinkClick"
                            >
                                ご挨拶
                            </router-link>
                        </li>
                        <li class="toggleMenu_item">
                            <router-link to="/branch-introduction"
                                         class="toggleMenu_link"
                                         @click.native="onLinkClick"
                            >
                                各支部校
                            </router-link>
                        </li>
                        <li class="toggleMenu_item">
                            <router-link to="/contact"
                                         class="toggleMenu_link"
                                         @click.native="onLinkClick"
                            >
                                お問い合わせ
                            </router-link>
                        </li>
                        <li class="toggleMenu_item">
                            <router-link to="/sign-in"
                                         class="toggleMenu_link"
                                         @click.native="onLinkClick"
                            >
                                Sign In
                            </router-link>
                        </li>
                        <li class="toggleMenu_item">
                            <router-link to="/entry-pre-seminar"
                                         class="toggleMenu_link el_btnA d-inline-block w_auto"
                                         @click.native="onLinkClick"
                            >
                                ENTRY
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import Velocity from 'velocity-animate';

export default {
    name: "ToggleMenu",
    data() {
        return {
            dir: DIR,
        }
    },
    components: {},
    mounted() {
        /**
         * ToggleMenu Open Event
         */
        window.addEventListener('doToggleMenuOpen', e => {
            Promise.resolve()
                .then(() => {
                    return new Promise(resolve => {
                        console.log('ハンバーガ:OPEN');
                        Velocity(this.$refs.toggleMenu, 'stop');
                        return resolve();
                    })
                })
                .then(() => {
                    Velocity(this.$refs.toggleMenu, 'fadeIn', {
                        duration: e.duration,
                    });
                })
        }, false);

        /**
         * ToggleMenu Close Event
         */
        window.addEventListener('doToggleMenuClose', e => {
            Promise.resolve()
                .then(() => {
                    console.log('ハンバーガー:CLOSE');
                    return new Promise(resolve => {
                        Velocity(this.$refs.toggleMenu, 'stop');
                        return resolve();
                    })
                })
                .then(() => {
                    Velocity(this.$refs.toggleMenu, 'fadeOut', {
                        duration: e.duration,
                    });
                })
        }, false);
    },
    methods: {
        /**
         * ハンバーガーボタンクリックイベントを発火させるためのカスタムイベントを登録
         */
        onLinkClick() {
            // カスタムイベント発行 イベント先-> Hamburger.vue
            window.dispatchEvent(new CustomEvent('clickHamburgerBtn'));
        },
    },
}
</script>

<style scoped lang="scss" src="../../assets/scss/modules/toggle-menu.scss">
</style>